import * as actionTypes from './actionTypes';
import { createActionObject } from '../../helpers/common';
import { fetchStationTimeOffset } from '../../helpers/api';

import * as api from '../api';

export const getStationTimeOffset = station => dispatch => {
  var targetDate = new Date();
  var timestamp = targetDate.getTime() / 1000 + targetDate.getTimezoneOffset() * 60 // Current UTC 
  return fetchStationTimeOffset(timestamp, station.latitude, station.longitude)
    .then(stationTimeOffset => dispatch(
      createActionObject(
        actionTypes.SET_STATION_TIME_OFFSET,
        { stationTimeOffset }
      )
    ));
}

export const setSelectStatisticsStation = stationName => dispatch => dispatch(
  createActionObject(
    actionTypes.SELECT_STATISTICS_STATION,
    { stationName }
  )
);

export const resetSelectStatisticsStation = () => dispatch => dispatch(
  createActionObject(
    actionTypes.RESET_STATISTICS_STATION,
    { data: "" }
  )
);

export const setSelectBiDirectionalStation = stationName => dispatch => dispatch(
  createActionObject(
    actionTypes.SELECT_BI_DIRECTIONAL_STATION,
    { stationName }
  )
);

export const resetBiDirectionalStation = () => dispatch => dispatch(
  createActionObject(
    actionTypes.RESET_BI_DIRECTIONAL_STATION,
    { data:[]}
  )
);

export const setSelectYear = selectedYear => dispatch => dispatch(
  createActionObject(
    actionTypes.SET_SELECT_YEAR,
    { selectedYear }
  )
);

export const callEnergyMeterList = (stnTitle) =>  dispatch => {
  api.energyMeterList(stnTitle)
    .then(({ data, status }) => {
      if (status === 200) {
        dispatch(
          createActionObject(
            actionTypes.GET_ENERGY_METER_LIST,
            { data: data }
          )
        )
      } else if (status === 500) {
        dispatch(
          createActionObject(
            actionTypes.GET_ENERGY_METER_LIST,
            { data: null }
          )
        )
      }
    });
};

export const callStatisticsTotalize = (stnTitle) =>  dispatch => {
  api.statisticTotalize(stnTitle)
    .then(({ data, status }) => {
      if (status === 200) {
        dispatch(
          createActionObject(
            actionTypes.GET_STATISTICS_TOTALIZE,
            { data: data }
          )
        )
      } else if (status === 500) {
        dispatch(
          createActionObject(
            actionTypes.GET_STATISTICS_TOTALIZE,
            { data: null }
          )
        )
      }
    });
};

export const selectStatisticsType = data => dispatch => dispatch(
  createActionObject(
    actionTypes.GET_STATISTICS_TYPE,
    { data }
  )
);

export const selectStatisticsFacilitys = data => dispatch => dispatch(
  createActionObject(
    actionTypes.GET_STATISTICS_FACILITYS,
    { data }
  )
);

export const callOtherData = (payload) => dispatch => {
  api.otherData(payload)
    .then(({ data, status }) => {
      if (status === 200) {
        dispatch(
          createActionObject(
            actionTypes.GET_OTHER_DATA,
            { data: data }
          )
        )
        // console.log("Data from API:", data);
      } else if (status === 500) {
        dispatch(
          createActionObject(
            actionTypes.GET_OTHER_DATA,
            { data: null }
          )
        )
      }
    });
};

export const callBiDirectionalMeter = (stnTitle) => dispatch => {
  return api.biDirectionalMeter(stnTitle) // Ensure the promise is returned
    .then(({ data, status }) => {
      if (status === 200) {
        dispatch(
          createActionObject(
            actionTypes.GET_BI_DIRECTIONAL_METER,
            { data: data }
          )
        );
        return data; // Return data for chaining
      } else if (status === 500) {
        dispatch(
          createActionObject(
            actionTypes.GET_BI_DIRECTIONAL_METER,
            { data: null }
          )
        );
        return null; // Return null for chaining
      }
    });
};

export const updateBiDirectionalMeterList = (meterList) => ({
  type: actionTypes.UPDATE_BI_DIRECTIONAL_METER_LIST,
  payload: meterList,
});
export const updateBiDirectionalEnergyFilter = (filter) => {
  console.log("Dispatching updateBiDirectionalEnergyFilter action with filter:", filter);
  return {
    type: actionTypes.UPDATE_BI_DIRECTIONAL_ENERGY_FILTER,
    payload: filter,
  };
};

export const selectView = view => dispatch => dispatch(
  createActionObject(
      actionTypes.SELECT_VIEW_PERIOD,
      { view }
  )
);

export const selectDay = day => dispatch => dispatch(
  createActionObject(
      actionTypes.SET_SELECTED_DAY,
      { day }
  )
)

export const selectMonth = month => dispatch => dispatch(
  createActionObject(
      actionTypes.SET_SELECTED_MONTH,
      { month }
  )
);

export const selectYear = year => dispatch => dispatch(
  createActionObject(
      actionTypes.SET_SELECTED_YEAR,
      { year }
  )
);

export const resetStatisticsView = () => ({
  type: actionTypes.RESET_STATISTICS_VIEW,
});

export const resetStatisticsDateSelections = () => ({
  type: actionTypes.RESET_STATISTICS_DATE_SELECTIONS,
});

export const updateBiDirectionalDates = (dates) => ({
  type: actionTypes.UPDATE_BI_DIRECTIONAL_DATES,
  payload: dates,
});

export const selectBiDirectionalFacility = data => dispatch => dispatch(
  createActionObject(
    actionTypes.GET_BI_DIRECTIONAL_FACILITIES,
    { data }
  )
);

export const callBiDirectionalEnergyDataDates = (payload) => dispatch => {
  dispatch({ type: actionTypes.GET_BI_DIRECTIONAL_DATA_DATES_REQUEST });

  // Ensure payload is correctly structured as expected by the API
  api.getDirectionalEnergyDataDates(payload)
      .then(response => {
          if (response.status === 200) {
              dispatch({
                  type: actionTypes.GET_BI_DIRECTIONAL_DATA_DATES_SUCCESS,
                  data: response.data // Ensure that this matches how your actual API response is structured
              });
          }
      })
      .catch(error => {
          dispatch({
              type: actionTypes.GET_BI_DIRECTIONAL_DATA_DATES_FAILURE,
              error: error.message || "An error occurred while fetching station energy date information."
          });
      });
};

export const callBiDirectionalEnergyData = (payload) => dispatch => {
  api.biDirectionalEnergyData(payload)
    .then(({ data, status }) => {
      if (status === 200) {
        dispatch(
          createActionObject(
            actionTypes.GET_BI_DIRECTIONAL_ENERGY_DATA,
            { data: data }
          )
        )
        // console.log("Data from API:", data);
      } else if (status === 500) {
        dispatch(
          createActionObject(
            actionTypes.GET_BI_DIRECTIONAL_ENERGY_DATA,
            { data: null }
          )
        )
      }
    });
};

export const resetBiDirectionalData = () => ({
  type: actionTypes.RESET_BI_DIRECTIONAL_DATA,
});
 

export const resetPortfolioData = () => ({
  type: actionTypes.RESET_PORTFOLIO_DATA,
});

export const resetPortfolioStatisticsData = () => ({
  type: actionTypes.RESET_PORTFOLIO_STATISTICS_DATA,
});

export const callPortfolioData = (payload) => (dispatch) => {
  api.getPortfolioData(payload)
    .then(({ data, status }) => {
      if (status === 200 && data) {
        dispatch(
          createActionObject(
            actionTypes.GET_PORTFOLIO_DATA,
            { data: data }
          )
        );
      } else {
        dispatch(
          createActionObject(
            actionTypes.GET_PORTFOLIO_DATA_FAILURE,
            { data: null } // Explicitly set to null
          )
        );
      }
    })
    .catch(() => {
      dispatch(
        createActionObject(
          actionTypes.GET_PORTFOLIO_DATA_FAILURE,
          { data: null } // Explicitly set to null on error
        )
      );
    });
};

export const setSelectedPortfolioCompany = selectedPortfolioCompany => dispatch => dispatch(
  createActionObject(
    actionTypes.SET_SELECTED_PORTFOLIO_COMPANY,
    { selectedPortfolioCompany }
  )
);

export const setSelectedPortfolioCity = selectedPortfolioCity => dispatch => dispatch(
  createActionObject(
    actionTypes.SET_SELECTED_PORTFOLIO_CITY,
    { selectedPortfolioCity }
  )
);

export const setSelectedPortfolioCountry = selectedPortfolioCountry => dispatch => dispatch(
  createActionObject(
    actionTypes.SET_SELECTED_PORTFOLIO_COUNTRY,
    { selectedPortfolioCountry }
  )
);

export const setSelectedPortfolioProject = selectedPortfolioProject => dispatch => dispatch(
  createActionObject(
    actionTypes.SET_SELECTED_PORTFOLIO_PROJECT,
    { selectedPortfolioProject }
  )
);

export const setSelectedPortfolioYear = selectedPortfolioYear => dispatch => dispatch(
  createActionObject(
    actionTypes.SET_SELECTED_PORTFOLIO_YEAR,
    { selectedPortfolioYear }
  )
);

export const setSelectedPortfolioStations = stationsData => dispatch => dispatch(
  createActionObject(
    actionTypes.SET_SELECTED_PORTFOLIO_STATIONS,
    { stationsData }
  )
);

export const fetchPortfolioDetails = (payload) => (dispatch) => {
  dispatch({ type: actionTypes.GET_PORTFOLIO_DETAILS_REQUEST });

  api.getPortfolioDetails(payload)
    .then(({ data, status }) => {
      if (status === 200) {
        dispatch(
          createActionObject(
            actionTypes.GET_PORTFOLIO_DETAILS_SUCCESS,
            { data: data }
          )
        );
        // Optionally log data or handle other success logic
      } else {
        dispatch(
          createActionObject(
            actionTypes.GET_PORTFOLIO_DETAILS_FAILURE,
            { data: null }
          )
        );
      }
    })
    .catch((error) => {
      dispatch(
        createActionObject(
          actionTypes.GET_PORTFOLIO_DETAILS_FAILURE,
          { error: error.message || "An error occurred while fetching portfolio details." }
        )
      );
    });
};

export const callPortfolioTotalize = (payload) => async (dispatch) => {
  try {
    const response = await api.portfolioTotalize(payload);
    if (response.status === 200 && response.data) {
      dispatch({
        type: actionTypes.GET_PORTFOLIO_TOTALIZE_DATA,
        payload: response.data  
      });
    } else {
      dispatch({
        type: actionTypes.GET_PORTFOLIO_TOTALIZE_FAILURE,
        payload: null
      });
    }
  } catch (error) {
    dispatch({
      type: actionTypes.GET_PORTFOLIO_TOTALIZE_FAILURE,
      payload: { error: error.message }
    });
  }
};

// Set Selected Portfolio Level
export const setSelectedPortfolioLevel = (selectedPortfolioLevel) => (dispatch) =>
  dispatch({
    type: actionTypes.SET_SELECTED_PORTFOLIO_LEVEL,
    selectedPortfolioLevel,
  });

// Reset Selected Portfolio Level
export const resetSelectedPortfolioLevel = () => (dispatch) =>
  dispatch({
    type: actionTypes.RESET_SELECTED_PORTFOLIO_LEVEL,
  });

// Fetch Portfolio Levels and Set Default to 'Country'
export const fetchPortfolioLevels = () => async (dispatch) => {
  dispatch({ type: actionTypes.FETCH_PORTFOLIO_LEVELS_REQUEST });
  try {
    const response = await api.getPortfolioLevel();
    const data = response.data;

    dispatch({
      type: actionTypes.FETCH_PORTFOLIO_LEVELS_SUCCESS,
      payload: data,
    });

    // Set 'Country' as default selection if available
    const defaultLevel = data.find(
      (level) => level.portfolioSelection.toLowerCase() === "country"
    );
    if (defaultLevel) {
      dispatch(setSelectedPortfolioLevel(defaultLevel.portfolioSelection));
    }
  } catch (error) {
    dispatch({
      type: actionTypes.FETCH_PORTFOLIO_LEVELS_FAILURE,
      error: error.message,
    });
  }
};

export const callPortfolioStatisticsData = (payload) => (dispatch) => {
  api.getPortfolioStatisticsData(payload)
    .then(({ data, status }) => {
      if (status === 200 && data) {
        dispatch(
          createActionObject(
            actionTypes.GET_PORTFOLIO_STATISTICS_DATA,
            { data: data }
          )
        );
      } else {
        dispatch(
          createActionObject(
            actionTypes.GET_PORTFOLIO_STATISTICS_DATA_FAILURE,
            { data: null } // Explicitly set to null
          )
        );
      }
    })
    .catch(() => {
      dispatch(
        createActionObject(
          actionTypes.GET_PORTFOLIO_STATISTICS_DATA_FAILURE,
          { data: null } // Explicitly set to null on error
        )
      );
    });
};

export const resetBiDirectionalMeterList = () => ({
  type: actionTypes.RESET_BI_DIRECTIONAL_METER_LIST,
  payload: { facilities: [] },
});

export const setPortfolioInfoCompany = selectedPortfolioInfoCompany => dispatch => dispatch(
  createActionObject(
    actionTypes.SET_PORTFOLIO_INFO_COMPANY,
    { selectedPortfolioInfoCompany }
  )
);

export const callPortfolioInfo = (payload) => async (dispatch) => {
  try {
    const response = await api.getPortfolioInfo(payload);
    if (response.status === 200 && response.data) {
      dispatch({
        type: actionTypes.GET_PORTFOLIO_INFO,
        payload: response.data  
      });
    } else {
      dispatch({
        type: actionTypes.GET_PORTFOLIO_INFO_FAILURE,
        payload: null
      });
    }
  } catch (error) {
    dispatch({
      type: actionTypes.GET_PORTFOLIO_INFO_FAILURE,
      payload: { error: error.message }
    });
  }
};